import { combine, withContext, withAsyncEffect } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import EventDetailsPanelComponent from './component'

export const EventDetailsPanel = combine(
  withContext('eventsStore', StoreContext, ({ events }) => events),
  withAsyncEffect({
    deps: ['eventId'],
    dataName: 'event',
    async asyncAction({ eventsStore }, { eventId }) {
      const event = await eventsStore.loadOne(eventId)
      return event
    },
  })
)(EventDetailsPanelComponent)
